import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { NgxLoadingModule } from 'ngx-loading';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ROUTES } from './app.routes';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './components/header/header.component';
import { HttpClientModule } from '@angular/common/http';
import { FooterComponent } from './components/footer/footer.component';
import { MaterialExports } from './material';
import { MatPaginatorIntlCro } from './paginatorLanguaje';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatIconModule } from '@angular/material/icon';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { SafePipe } from './custom.pipe';
import { SanitizeHtmlPipe } from './pipes/sanitize-html.pipe';
import { MetaModule } from '@ngx-meta/core';
import { FormsModule } from '@angular/forms'; import { ReactiveFormsModule } from '@angular/forms';
import * as $ from 'jquery';
//import { createTextMaskInputElement } from 'angular2-text-mask';
import { MatStepperModule } from '@angular/material/stepper';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgxSpinnerModule } from "ngx-spinner";
import { CookieService } from 'ngx-cookie-service';
import { NgxCaptchaModule } from 'ngx-captcha'; 
import { RecaptchaModule } from "ng-recaptcha";
import { BotDetectCaptchaModule } from 'angular-captcha'; 

import { ConsultaComponent } from './components/consulta/consulta.component';
import { CallbackComponent } from './components/callback/callback.component';
import { ErrorComponent } from './components/error/error.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    NotFoundComponent,
    SafePipe,
    SanitizeHtmlPipe,
    ConsultaComponent,
    CallbackComponent,
    ErrorComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    RouterModule.forRoot(ROUTES, { useHash: true, relativeLinkResolution: 'legacy' }),
    //RouterModule.forRoot(ROUTES, { useHash: false, relativeLinkResolution: 'legacy' }),//Para no utilizar # en la URL
    //RouterModule.forRoot(ROUTES, {onSameUrlNavigation: 'reload'}),
    HttpClientModule,
    BrowserAnimationsModule,
    MaterialExports,
    PdfViewerModule,
    MetaModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    FormsModule,
    MatTableModule,
    MatInputModule,
    MatButtonModule,
    NgxLoadingModule.forRoot({}),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    MatStepperModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatExpansionModule,
    MatIconModule,
    NgxSpinnerModule,
    NgxCaptchaModule,
    RecaptchaModule,
    BotDetectCaptchaModule
  ],
  exports: [RouterModule],
  providers: [CookieService],
  bootstrap: [AppComponent],
  entryComponents: []
})

export class AppModule { }